import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const o=t("kingdom_of_denmark",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <rect
                y="4.5"
                width="24"
                height="16"
                fill="white" />
            <path
                d="M0 4.5H19.2897L9.19626 11.3571V13.6429L19.2897 20.5H0V4.5Z"
                fill="#C8102E" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.38318 11.3571V4.5H7.17757V11.3571H13.9065V13.6429H7.17757V20.5H5.38318V13.6429H0V11.3571H5.38318Z"
                fill="white" />
        </svg>
    `),r=t("kingdom_of_denmark_rounded",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19470_66576)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <rect
                    x="-6.20703"
                    y="0.5"
                    width="45.8571"
                    height="24"
                    fill="white" />
                <path
                    d="M-6.20703 0.5H30.6501L11.3644 10.7857V14.2143L30.6501 24.5H-6.20703V0.5Z"
                    fill="#C8102E" />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.07868 10.7857V0.5H7.50725V10.7857H20.3644V14.2143H7.50725V24.5H4.07868V14.2143H-6.20703V10.7857H4.07868Z"
                    fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_19470_66576">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{o as KingdomOfDenmark,r as KingdomOfDenmarkRounded};
